export { default as ProductQuery } from "./ProductQuery.graphql";
export { default as ProductContentsQuery } from "./ProductContentsQuery.graphql";
export { default as CreateProductFeedbackMutation } from "./CreateProductFeedbackMutation.graphql";
